export const ROUTE_PRELOAD_DATA_KEY = 'preload';
export const ROUTE_PRELOAD_KEY_DATA_KEY = 'preloadKey';

export const RoutePreloadMode = {
    Eager: 'eager',
    Intent: 'intent',
} as const;

export type RoutePreloadMode =
    (typeof RoutePreloadMode)[keyof typeof RoutePreloadMode];
